<template>
  <modal
    v-slot="{ data }"
    name="orderHistoryReceipt"
    @closed="closedHandler"
  >
    <order-history-receipt
      :receipt="data.order"
    />
  </modal>

</template>


<script>
  import { mapGetters, mapState } from 'vuex';

  import OrderHistoryReceipt from './order-history-receipt/index.vue';


  export default {
    name: 'OrderHistoryReceiptModal',

    components: {
      OrderHistoryReceipt
    },

    computed: {
      ...mapState('orderHistory', ['ratingsForOrders']),
      ...mapGetters('merchant', ['merchant']),

      hasRatingsForOrdersUpdated() {
        return Object.keys(this.ratingsForOrders).length;
      },

      isOrderHistoryRatingEnabled() {
        return this.merchant.features['item-rating-enabled'] && this.merchant.features['order-history-receipt-rating-enabled'];
      }
    },

    methods: {
      closedHandler() {
        /**
         * NOTE:
         * Only re-request order history orders if a user updated their item rating, as ratingsForOrders will contain keys that
         * correspond to orderId's that only get set when a user changes their existing item rating.
         */
        if (this.isOrderHistoryRatingEnabled && this.hasRatingsForOrdersUpdated) {
          this.$store.dispatch('orderHistory/getOrders');

          this.$store.commit('orderHistory/SET_RATINGS_FOR_ORDERS');
        }
      }
    }
  };
</script>
